
import { apiGet, apiPost, apiPut, apiDelete } from "./index";

export interface Measure {
    id?: string;
    name: string;
    expression: string;
    format?: string;
    description?: string;
}

export interface Table {
    id?: string;
    name: string;
    type: "PHYSICAL" | "VIRTUAL";
    source_connection_id?: string;
    source_table_name?: string;
    sql_definition?: string;
    position_x?: number;
    position_y?: number;
    columns?: any[];
}

export interface Relationship {
    id?: string;
    from_table_id: string;
    to_table_id: string;
    join_type: "INNER" | "LEFT" | "RIGHT" | "FULL" | "CROSS";
    join_condition: string;
}

export interface DataModel {
    id?: string;
    name: string;
    description?: string;
    is_active?: boolean;
    layout_json?: any;
    connection_id?: string;  // Selected database connection
    model_definition?: {
        tables?: Table[];
        relationships?: Relationship[];
        measures?: Measure[];
    };
    model_version?: number;
    parent_model_id?: string;
    storage_mode?: string;
    data_layer?: string;
    refresh_schedule?: string;
    last_refresh_duration?: number;
    last_refresh_rows?: number;
}

export interface Connection {
    id: string;
    name: string;
    provider: string;
}

export interface DBTable {
    name: string;
    schema?: string;
    type?: string;
}

const BASE_URL = "/datamodels";
const CONN_URL = "/connections";

export const getDataModels = (token: string) =>
    apiGet(BASE_URL, token);

export const getDataModel = (id: string, token: string) =>
    apiGet(`${BASE_URL}/${id}`, token);

export const createDataModel = (data: DataModel, token: string) =>
    apiPost(BASE_URL, token, data);

export const updateDataModel = (id: string, data: Partial<DataModel>, token: string) =>
    apiPut(`${BASE_URL}/${id}`, token, data);

export const deleteDataModel = (id: string, token: string) =>
    apiDelete(`${BASE_URL}/${id}`, token);


export const refreshDataModel = (id: string, token: string) =>
    apiPost(`${BASE_URL}/${id}/refresh`, token, {});

export const getRefreshStatus = (id: string, token: string) =>
    apiGet(`${BASE_URL}/${id}/refresh-status`, token);

// Connection APIs
export const getConnections = (token: string) =>
    apiGet(`${CONN_URL}/global`, token);

export const getConnectionTables = (connectionId: string, token: string) =>
    apiGet(`${CONN_URL}/${connectionId}/schemas`, token);

export const getTableColumns = (connectionId: string, tableName: string, token: string) =>
    apiGet(`${CONN_URL}/${connectionId}/tables/${tableName}/columns`, token);
